export default "__VITE_ASSET__f79834b6__"